import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import { newsList } from "@/mocks/news";

export default function LatestNews() {
  const latest = newsList.slice(0, 6);
  const ranking = newsList.slice(0, 5);

  return (
    <section className="w-full bg-background-100 border-y border-background-200 px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-1 h-6 rounded-full bg-accent-500"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">最新动漫资讯</h2>
            </div>
            <p className="text-sm text-foreground-500">按发布时间倒序，第一时间掌握动漫圈动态</p>
          </div>
          <Link
            to="/news"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            全部资讯
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {latest.map((item) => (
              <NewsCard key={item.id} news={item} />
            ))}
          </div>

          <aside className="rounded-lg bg-background-50 border border-background-200 p-5 h-fit">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-7 h-7 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-fire-fill"></i>
              </span>
              <h3 className="text-base font-bold text-foreground-950">资讯热榜</h3>
            </div>
            <ol className="space-y-1">
              {ranking.map((item, i) => (
                <li key={item.id}>
                  <Link
                    to={`/news/detail/${item.id}`}
                    className="group flex items-start gap-3 py-2.5 border-b border-background-100 last:border-0"
                  >
                    <span
                      className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold ${
                        i < 3 ? "bg-primary-600 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="text-sm text-foreground-700 group-hover:text-primary-700 transition-colors leading-relaxed wf-line-clamp-2">
                      {item.title}
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </aside>
        </div>
      </div>
    </section>
  );
}